export const capitalizeFirstLetter = (str: string): string =>
  str ? `${str[0].toUpperCase()}${str.slice(1)}` : ''

export const toTitleCase = (str: string): string =>
  str
    ? str
        .toLowerCase()
        .split(' ')
        .map((word) => capitalizeFirstLetter(word))
        .join(' ')
    : ''

const SPECIAL_MAP: Record<string, string> = {
  // Latin ligatures
  æ: 'ae',
  Æ: 'ae',
  œ: 'oe',
  Œ: 'oe',
  ß: 'ss',

  // Icelandic
  ð: 'd',
  Ð: 'd',
  þ: 'th',
  Þ: 'th',

  // Polish, Czech, Slovak, Hungarian
  ł: 'l',
  Ł: 'l',
  ø: 'o',
  Ø: 'o',
  ń: 'n',
  Ń: 'n',
  ć: 'c',
  Ć: 'c',
  č: 'c',
  Č: 'c',
  š: 's',
  Š: 's',
  ž: 'z',
  Ž: 'z',
  ď: 'd',
  Ď: 'd',
  ť: 't',
  Ť: 't',
  ŕ: 'r',
  Ŕ: 'r',

  // French / other
  ÿ: 'y',
  Ÿ: 'y',
  ç: 'c',
  Ç: 'c',
  ĵ: 'j',
  Ĵ: 'j',

  // Other Latin extended letters
  ū: 'u',
  Ū: 'u',
  ů: 'u',
  Ů: 'u',
  ű: 'u',
  Ű: 'u',
  ǖ: 'u',
  ǘ: 'u',
  ǚ: 'u',
  ǜ: 'u',
  ĳ: 'ij',
  Ĳ: 'ij'
}

export const normalizeString = (s: string): string => {
  // 1. normalizes NFD and Removes all accents
  const removeAccents = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

  // 2. Replacement of special characters
  return removeAccents
    .split('')
    .map((char) => SPECIAL_MAP[char] || char)
    .join('')
}
